import Api from "../lib/api/api";
import { handleError } from "../utils/constants";

export const getTdmRoutes = (token) => async (dispatch) => {
    try {
        dispatch({
            type: 'GET_TDM_ROUTES',
        });
        const api = new Api(token);
        const resp = await api.tdm.getTdmRoutes()
        dispatch({
            type: 'GET_TDM_ROUTES_SUCCESS',
            data: resp
        });
        return resp
    } catch (error) {
        dispatch({
            type: 'GET_TDM_ROUTES_ERROR',
        });
        handleError(error, "Unable to fetch tdm routes")
    }
};
